import { useTranslation } from "react-i18next";
import { Clock, Wallet } from "lucide-react";
import { EmptyState } from "@/components/ui";
import { TransactionItem, ListResultsCard } from "@/components/common";
import type { WalletTransaction } from "@/types";

interface RecentTransactionsProps {
  transactions: WalletTransaction[];
}

/**
 * Recent transactions card for the dashboard.
 */
export function RecentTransactions({ transactions }: RecentTransactionsProps) {
  const { t } = useTranslation("dashboard");

  return (
    <ListResultsCard
      title={
        <span className="flex items-center gap-2.5">
          <span className="border-surface-200 bg-surface-50 text-surface-600 flex h-7 w-7 shrink-0 items-center justify-center rounded-md border">
            <Clock
              className="h-4 w-4"
              aria-hidden
            />
          </span>
          {t("shared.recentTransactionsTitle")}
        </span>
      }
      contentClassName="px-5 py-4"
      isEmpty={transactions.length === 0}
      emptyState={
        <EmptyState
          size="md"
          icon={Wallet}
          title={t("shared.recentTransactionsEmpty")}
          description={t("shared.recentTransactionsHint")}
        />
      }
    >
      <div className="space-y-2">
        {transactions.map((transaction) => (
          <TransactionItem
            key={transaction.id}
            transaction={transaction}
            compact
          />
        ))}
      </div>
    </ListResultsCard>
  );
}
